import { createSlice, current } from '@reduxjs/toolkit';
import { AppConstants } from '../constants/AppConstants';

const initialState: any = {
  configCatalog: null as any,
  selectedConfig: null as any,
  dirtyConfiguraion: {} as any,
  flags: {
    isEdit: false,
    loading: true,
    recallConfig: false
  } as any,
  selectedConfigOrg: [],
  instanceData: {
    [AppConstants.FIELD_LAYOUT_OBJECT_NAME]: [],
    [AppConstants.FIELD_GROUP_OBJECT_NAME]: [],
    [AppConstants.FIELD_METADATA_OBJECT_NAME]: []
  }
};
export const mobileConfigurationSlice = createSlice({
  name: 'mobileConfiguration',
  initialState,
  reducers: {
    setSelectedConfig: (state, action) => {
      state.selectedConfig = action.payload;
    },
    setConfigList: (state, action) => {
      state.configCatalog = action.payload;
    },
    setMobileConfigFlags: (state, action) => {
      const updateObject = action.payload;
      Object.keys(updateObject).forEach((key) => {
        state.flags[key] = updateObject[key];
      });
    },
    setDirtyConfiguration: (state, action) => {
      state.dirtyConfiguraion = action.payload;
    },

    deleteDirtyConfiguration: (state, action) => {
      const stateClone = Object.assign({}, state);
      const { key, category } = action.payload;
      delete stateClone.dirtyConfiguraion?.[category]?.fieldValues[key];
      delete stateClone.dirtyConfiguraion?.[category]?.fieldErrors[key];
      state.dirtyConfiguraion = stateClone.dirtyConfiguraion;
    },

    setSelectedConfigOrg: (state, action) => {
      state.selectedConfigOrg = action.payload;
    },
    setMobileConfigInstanceData: (state, action) => {
      const updateObject = action.payload;
      Object.keys(updateObject).forEach((key) => {
        state.instanceData[key] = updateObject[key];
      });
    },
    resetMobileConfigReducer: () => initialState
  }
});

export const {
  setSelectedConfig,
  setConfigList,
  setDirtyConfiguration,
  deleteDirtyConfiguration,
  setMobileConfigFlags,
  setSelectedConfigOrg,
  resetMobileConfigReducer,
  setMobileConfigInstanceData
} = mobileConfigurationSlice.actions;

export default mobileConfigurationSlice.reducer;
